/**
 * 运行环境相关（从 app utils 迁入，供 packages 使用）
 * 依赖 @fs/utils 的 getQueryString、isTHSApp、isDeviceMobile、getRunEnv
 */
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { getQueryString, isTHSApp, isDeviceMobile, getRunEnv } from '@fs/utils'

/** 获取当前接口版本：v0 网厅，v1 自研/站外 */
export const getPathVersion = () => {
  const runEnv = getRunEnv()
  return runEnv === 2 ? 'v0' : 'v1'
}

/** 获取页面来源：1同花顺公版 2同花顺OEM 3Web网厅 4移动网厅 5利通天下 6自研APP */
export const getOrigin = () => {
  if (JSBridge) return 6
  if (isTHSApp()) return 1
  return isDeviceMobile() ? 4 : 3
}

export const getThemeType = () => {
  const DEFAULT_SKIN_TYPE = 'white'
  if (isTHSApp()) {
    const ua = navigator.userAgent
    const index = ua.indexOf('hxtheme')
    if (index > -1) {
      const match = ua.substr(index + 8, 1)
      return match === '1' ? 'black' : 'white'
    }
    return 'white'
  }
  const KEY = 'skinType'
  const reg = new RegExp(`(?:${KEY})/([^\\s]+)`)
  return (
    (window.navigator.userAgent.match(reg) || [])[1] ||
    getQueryString(KEY) ||
    getQueryString(KEY, true) ||
    localStorage.getItem(KEY) ||
    DEFAULT_SKIN_TYPE
  )
}

export const getPriceColorType = () => {
  const KEY = 'priceColorType'
  const reg = new RegExp(`(?:${KEY})/([^\\s]+)`)
  return (
    (window.navigator.userAgent.match(reg) || [])[1] ||
    getQueryString(KEY) ||
    getQueryString(KEY, true) ||
    localStorage.getItem(KEY) ||
    1
  )
}
